import api from "../../../services/api";

export const getTerms = () => api.get("/quotation-terms");
export const createTerm = (data) => api.post("/quotation-terms", data);
export const updateTerm = (id, data) => api.patch(`/quotation-terms/${id}`, data);
export const deleteTerm = (id) => api.delete(`/quotation-terms/${id}`);

export const toggleActive = (id, isActive) => api.patch(`/quotation-terms/${id}`, { isActive });
